// @react
import React, { ReactElement } from 'react'
// @libraries
import { makeStyles } from '@material-ui/core/styles'
// @components
import Icon from '@bit/atd.web.icons'
import Spacer from '@bit/atd.web.spacer'
import Link from '@bit/atd.web.header-link'
import Grid from '@bit/atd.web.grid'
// @constants
import { ExternalRouteNames } from 'constants/routeNames'

const useStyles = makeStyles({
  linkWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0',
    marginRight: 16,
    '&:last-child': {
      paddingRight: 0,
      marginRight: 0,
    },
  },
  menu: {
    fontWeight: 500,
  },
})

const TopLinks = (): ReactElement => {
  /********************************
   * HOOKS
   ********************************/

  const classes = useStyles()

  /********************************
   * RENDER
   ********************************/

  return (
    <Grid container justify="flex-end" alignItems="center">
      <Grid item className={classes.linkWrapper}>
        <Link
          href={ExternalRouteNames.ATD_ENTERPRISE_HOME}
          className={classes.link}
        >
          Enterprise Solutions
        </Link>

        <Link href={ExternalRouteNames.ATD_CHAPTERS} className={classes.link}>
          Chapters
        </Link>

        <Link
          href={ExternalRouteNames.ATD_GLOBAL_HOME}
          className={classes.link}
        >
          <Icon glyph="globe" size={16} />
          <Spacer size={4} />
          <span>ATD Global</span>
        </Link>

        <Link
          href={ExternalRouteNames.ATD_PHONE_GLOBAL}
          className={classes.link}
        >
          +1.800.628.2783
        </Link>
      </Grid>
    </Grid>
  )
}

export default TopLinks
